var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "px-10 flex flex-col justify-center items-center absolute w-full h-full top-0 left-0 bg-white bg-opacity-70 z-10"
};
const _hoisted_2 = { class: "w-full flex-row grid grid-cols-2 justify-center gap-1 border-b border-slate-300" };
const _hoisted_3 = {
    class: "flex flex-col border-r border-slate-300 pr-8 hl-variation-left pb-8 overflow-y-auto",
    style: { "max-height": "590px", "padding-right": "1.5rem" }
};
const _hoisted_4 = {
    class: "w-full space-y-1",
    style: { "flex": "0 0 auto" }
};
const _hoisted_5 = {
    key: 0,
    class: "text-gray-700 flex items-start font-normal text-start space-x-2"
};
const _hoisted_6 = { class: "font-medium flex-none" };
const _hoisted_7 = { class: "w-[555px] flex-shrink" };
const _hoisted_8 = {
    key: 1,
    class: "text-gray-700 flex flex-1 font-normal text-start space-x-1 mb-3"
};
const _hoisted_9 = { class: "font-medium flex-none" };
const _hoisted_10 = {
    key: 2,
    class: "flex flex-row justify-start mb-3"
};
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "w-full mb-3 border-t border-gray-200 h-px" }, null, -1 /* HOISTED */);
const _hoisted_12 = { class: "pl-2 pr-2 grid grid-cols-2 gap-4" };
const _hoisted_13 = { class: "text-center" };
const _hoisted_14 = { class: "pl-8 space-y-3 flex flex-col justify-start items-start" };
import UIImagePreview from '@/components/common/UIImagePreview.vue';
import { fieldsMapping } from '@/compositions/imageAIFormFields';
import { DEFAULT_FIELD_MAPPING_KEY, IMAGE_GENERATION_DEFAULTS, MEDIA_LIBRARY_FOLDER_NAME, } from '@/helper/const';
import { MediaServices } from '@/service/MediaService';
import { RefreshCcw02Icon, Save01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIHeader, UIModal, UIModalContent, UIModalFooter, UIModalHeader, UISpace, UISpin, UITag, UITextSmMedium, UITextSmRegular, UITooltip, } from '@gohighlevel/ghl-ui';
import { computed, inject, onMounted, reactive, ref, watch, } from 'vue';
import { ContentAIServices } from '../../service/ContentAIService';
import { FormFieldNames } from '../../types';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalShowImageVariations',
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        transactionId: {
            type: String,
            default: '',
        },
        hideControls: {
            type: Boolean,
            default: false,
        },
        productType: {
            type: String,
            require: true,
        },
    },
    emits: ['close', 'regenerate', 'imageId'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const route = inject('route');
        const loading = ref(false);
        const updating = ref(false);
        const id = computed(() => props.transactionId);
        const show = computed(() => props.showModal);
        const formFields = computed(() => fieldsMapping[props.productType]
            ? fieldsMapping[props.productType]
            : fieldsMapping[DEFAULT_FIELD_MAPPING_KEY]);
        const imageVariations = reactive([]);
        const imageAIData = reactive({
            description: IMAGE_GENERATION_DEFAULTS.DESCRIPTION,
            preset: IMAGE_GENERATION_DEFAULTS.PRESET,
            numberOfVariations: IMAGE_GENERATION_DEFAULTS.NUMBER_OF_VARIATIONS,
        });
        const selectedVariation = ref();
        const selectedVariationSrc = ref('');
        watch(show, (newVal, oldVal) => __awaiter(this, void 0, void 0, function* () {
            if (newVal !== oldVal && newVal === true) {
                selectedVariation.value = undefined;
                selectedVariationSrc.value = '';
            }
            if (id.value && show.value) {
                yield fetchImageVariations();
            }
        }));
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            if (id.value)
                yield fetchImageVariations();
        }));
        const setSelectedVariation = imageVariation => {
            selectedVariation.value = imageVariation;
            selectedVariationSrc.value = imageVariation.src;
        };
        const resetSelectedVariation = () => {
            selectedVariation.value = undefined;
        };
        function submitVariation() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (updating.value)
                        return;
                    updating.value = true;
                    const body = {
                        imageUsed: selectedVariation.value.src,
                        locationId: (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id,
                        variation: imageVariations.map(variation => ({
                            id: variation.id,
                            usedInPost: variation.id === selectedVariation.value.id,
                        })),
                    };
                    yield ContentAIServices.updateImageById(id.value, body);
                    updating.value = false;
                    saveToMediaLibrary(selectedVariation.value);
                    emits('imageId', id.value);
                    updating.value = false;
                    closeModal();
                }
                catch (error) {
                    console.error(error);
                    updating.value = false;
                }
            });
        }
        function fetchImageVariations() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    loading.value = true;
                    const { data } = yield ContentAIServices.getImageVariationsById(id.value, (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id);
                    const newData = (_b = data === null || data === void 0 ? void 0 : data.variations) === null || _b === void 0 ? void 0 : _b.map(variation => ({
                        id: variation._id,
                        src: variation.response,
                        metaData: variation.metaData,
                        usedInPost: variation.usedInPost,
                        saving: false,
                        saved: false,
                    }));
                    if (newData)
                        imageVariations.splice(0, imageVariations.length, ...newData);
                    Object.assign(imageAIData, {
                        description: data.description,
                        preset: data.preset,
                        numberOfVariations: data.numberOfVariations,
                        type: data.type,
                    });
                    if (imageVariations.length > 0) {
                        const usedInPostVariation = imageVariations.find(variation => variation.usedInPost === true);
                        if (usedInPostVariation) {
                            setSelectedVariation(usedInPostVariation);
                        }
                        else {
                            setSelectedVariation(imageVariations[0]);
                        }
                    }
                    loading.value = false;
                }
                catch (error) {
                    console.error(error);
                    loading.value = false;
                }
            });
        }
        function closeModal() {
            if (updating.value || loading.value)
                return;
            emits('close');
            resetSelectedVariation();
        }
        function regenerateImages() {
            emits('regenerate', {
                source: props.productType,
                formValues: {
                    description: imageAIData === null || imageAIData === void 0 ? void 0 : imageAIData.description,
                    numberOfVariations: imageAIData === null || imageAIData === void 0 ? void 0 : imageAIData.numberOfVariations,
                    preset: imageAIData === null || imageAIData === void 0 ? void 0 : imageAIData.preset,
                },
            });
            resetSelectedVariation();
        }
        function saveToMediaLibrary(imageVariation) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (imageVariation.saving)
                        return;
                    imageVariation.saving = true;
                    yield MediaServices.uploadMedia({
                        mediaUrl: imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.src,
                        locationId: (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id,
                        folderName: MEDIA_LIBRARY_FOLDER_NAME,
                    });
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    imageVariation.saving = false;
                    imageVariation.saved = true;
                }
            });
        }
        function snakeToTitleCase(snakeCaseString) {
            if (snakeCaseString)
                return snakeCaseString
                    .split('_')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                    .join(' ');
            return '';
        }
        function formatImageMetadata(imageVariation) {
            if (!imageVariation || !imageVariation.metaData) {
                return '';
            }
            const { metaData } = imageVariation;
            const sizeInMB = metaData.size
                ? (metaData.size / (1024 * 1024)).toFixed(1)
                : '';
            const dimensions = metaData.width && metaData.height
                ? `${metaData.width}x${metaData.height}`
                : '';
            if (!sizeInMB || !dimensions) {
                return '';
            }
            return `${sizeInMB}MB • ${dimensions}`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: __props.showModal,
                width: 1000
            }, _createSlots({
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "image-ai-image-new-post-variations-modal-header",
                        title: _ctx.$t('modalShowImageVariations.imageAi'),
                        description: "",
                        onClose: closeModal
                    }, null, 8 /* PROPS */, ["title"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), { id: "image-ai-new-post-variations-modal-content" }, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d;
                            return [
                                (loading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _createVNode(_unref(UISpin), { size: "large" })
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            ((_b = (_a = _unref(formFields)) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.includes(_unref(FormFieldNames).DESCRIPTION))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('modalShowImageVariations.description')) + ": ", 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_7, _toDisplayString(imageAIData === null || imageAIData === void 0 ? void 0 : imageAIData.description), 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            ((_d = (_c = _unref(formFields)) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.includes(_unref(FormFieldNames).PRESET))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('modalShowImageVariations.style')) + ": ", 1 /* TEXT */),
                                                    _createElementVNode("span", null, _toDisplayString(snakeToTitleCase(imageAIData === null || imageAIData === void 0 ? void 0 : imageAIData.preset)), 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            (!__props.hideControls)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                    _createVNode(_unref(UITag), {
                                                        type: "info",
                                                        class: "cursor-pointer",
                                                        onClick: regenerateImages
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UISpace), { align: "center" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(RefreshCcw02Icon), { class: "w-4 h-4" }),
                                                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('modalShowImageVariations.regenerateImage')), 1 /* TEXT */)
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _hoisted_11,
                                            _createVNode(_unref(UIHeader), {
                                                id: "image-ai-new-post-variations-modal-header",
                                                secondaryTitle: _ctx.$t('modalShowImageVariations.variations')
                                            }, null, 8 /* PROPS */, ["secondaryTitle"]),
                                            _createElementVNode("div", _hoisted_12, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageVariations, (imageVariation, index) => {
                                                    var _a, _b, _c, _d, _e;
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.id,
                                                        class: _normalizeClass({
                                                            'flex flex-wrap justify-end': true,
                                                            'scale-on-hover': (imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.id) != ((_a = selectedVariation.value) === null || _a === void 0 ? void 0 : _a.id),
                                                            'selected-scale': (imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.id) === ((_b = selectedVariation.value) === null || _b === void 0 ? void 0 : _b.id),
                                                        })
                                                    }, [
                                                        (_openBlock(), _createBlock(UIImagePreview, {
                                                            class: "drop-shadow-2xl mt-2 cursor-pointer rounded ripple-effect",
                                                            onClick: ($event) => (setSelectedVariation(imageVariation)),
                                                            key: (_c = selectedVariation.value) === null || _c === void 0 ? void 0 : _c.id,
                                                            imageSrc: imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.src,
                                                            selected: (imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.id) === ((_d = selectedVariation.value) === null || _d === void 0 ? void 0 : _d.id),
                                                            width: "190px",
                                                            height: "190px",
                                                            borderWidth: "4px",
                                                            variationTag: `V${index + 1}`,
                                                            style: _normalizeStyle((imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.id) === ((_e = selectedVariation.value) === null || _e === void 0 ? void 0 : _e.id)
                                                                ? 'border: 2px solid #155EEF;'
                                                                : '')
                                                        }, null, 8 /* PROPS */, ["onClick", "imageSrc", "selected", "variationTag", "style"])),
                                                        (__props.hideControls)
                                                            ? (_openBlock(), _createBlock(_unref(UITooltip), {
                                                                key: 0,
                                                                placement: "left"
                                                            }, {
                                                                trigger: _withCtx(() => {
                                                                    var _a;
                                                                    return [
                                                                        _createVNode(_unref(UIButton), {
                                                                            id: "image-ai-variations-modal-select-btn",
                                                                            class: "mt-2",
                                                                            onClick: ($event) => (__props.hideControls
                                                                                ? saveToMediaLibrary(imageVariation)
                                                                                : setSelectedVariation(imageVariation)),
                                                                            type: __props.hideControls
                                                                                ? 'default'
                                                                                : (imageVariation === null || imageVariation === void 0 ? void 0 : imageVariation.id) != ((_a = selectedVariation.value) === null || _a === void 0 ? void 0 : _a.id)
                                                                                    ? 'default'
                                                                                    : 'primary',
                                                                            loading: imageVariation.saving,
                                                                            disabled: __props.hideControls && imageVariation.saved
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createVNode(_unref(Save01Icon), { class: "w-4 h-4" })
                                                                            ]),
                                                                            _: 2 /* DYNAMIC */
                                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "type", "loading", "disabled"])
                                                                    ];
                                                                }),
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('modalShowImageVariations.saveToLibrary')), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */))
                                                            : _createCommentVNode("v-if", true)
                                                    ], 2 /* CLASS */));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createVNode(_unref(UITextSmMedium), null, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('modalShowImageVariations.selectedImage')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }),
                                        _createVNode(UIImagePreview, {
                                            imageSrc: selectedVariationSrc.value,
                                            width: "430px",
                                            height: "430px",
                                            borderWidth: "8px",
                                            class: "mt-2",
                                            spinnerClass: "w-8 h-8"
                                        }, null, 8 /* PROPS */, ["imageSrc"]),
                                        _createVNode(_unref(UITextSmRegular), { class: "mt-2 mb-2" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(`${formatImageMetadata(selectedVariation.value)}`), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (!__props.hideControls)
                    ? {
                        name: "footer",
                        fn: _withCtx(() => [
                            _createVNode(_unref(UIModalFooter), {
                                positiveText: _ctx.$t('modalShowImageVariations.continue'),
                                negativeText: _ctx.$t('modalShowImageVariations.cancel'),
                                onNegativeClick: closeModal,
                                id: "image-ai-new-variations-modal-footer",
                                onPositiveClick: submitVariation,
                                loading: updating.value,
                                disabled: !selectedVariation.value
                            }, null, 8 /* PROPS */, ["positiveText", "negativeText", "loading", "disabled"])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"]));
        };
    }
});
